<template>
  <v-row align="center" justify="center">
    <v-col cols="12">
      <v-card shaped>
        <v-card-title>
          <v-icon large left color="primary">mdi-file-document-multiple-outline</v-icon>
          <span class="title font-weight-light">Договоры компаний</span>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :loading="loading.download"
            :disabled="loading.report"
            @click="DownloadReport"
          >
            <v-icon left>mdi-microsoft-excel</v-icon>Скачать Excel
          </v-btn>
        </v-card-title>
        <v-col>
          <v-expansion-panels flat>
            <v-expansion-panel>
              <v-expansion-panel-header>Немного об отчёте</v-expansion-panel-header>
              <v-expansion-panel-content>
                <p class="text-justify mb-1">
                  Договоры PharmIT с компаниями-клиентами: файл, БИН и срок истечения вносит менеджер в
                  «Управление → Компании → Договоры». Договор заключается на БИН, поэтому строка отчёта —
                  компания + БИН с последним договором по этому БИН, а также БИН, по которым договора нет.
                </p>
                <p class="text-justify mb-0">
                  Статусы: «Действует» — до срока больше 30 дней; «Заканчивается» — осталось 30 дней и меньше;
                  «Истёк» — срок прошёл; «Отсутствует» — по БИН нет ни одного договора (только у компаний с действующим комплектом).
                </p>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <v-form ref="form" @submit.prevent="LoadReport">
          <v-row class="px-4">
            <v-col cols="12" sm="6" md="3">
              <v-select
                v-model="search.status"
                :items="statusOptions"
                item-text="text"
                item-value="value"
                label="Статус"
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="2">
              <v-text-field v-model="search.expirationFrom" type="date" label="Срок истечения с"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="2">
              <v-text-field v-model="search.expirationTo" type="date" label="Срок истечения по"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                v-model="search.search"
                label="Компания или БИН"
                prepend-icon="mdi-magnify"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="2" class="d-flex align-center">
              <v-btn color="primary" type="submit" :loading="loading.report" block>Применить</v-btn>
            </v-col>
            <v-col cols="12" class="pt-0">
              <v-checkbox
                v-model="search.includeMissing"
                label="Показывать компании без договора"
                dense
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-form>

        <v-row class="px-4 pb-2">
          <v-col cols="auto"><v-chip color="green" dark>Действует: {{ report.activeCount }}</v-chip></v-col>
          <v-col cols="auto"><v-chip color="orange" dark>Заканчивается (≤ 30 дн.): {{ report.expiringCount }}</v-chip></v-col>
          <v-col cols="auto"><v-chip color="red" dark>Истёк: {{ report.expiredCount }}</v-chip></v-col>
          <v-col cols="auto"><v-chip color="grey" dark>Без договора: {{ report.missingCount }}</v-chip></v-col>
        </v-row>

        <v-data-table
          :headers="headers"
          :items="report.rows"
          :loading="loading.report"
          :items-per-page="20"
          :footer-props="{ 'items-per-page-options': [20, 50, 100, -1] }"
          class="elevation-1"
        >
          <template v-slot:item.expirationDate="{ item }">
            {{ item.expirationDate ? $options.filters.toDate(String(item.expirationDate).substr(0, 10)) : "" }}
          </template>
          <template v-slot:item.createdDate="{ item }">
            {{ item.createdDate ? $options.filters.toDate(String(item.createdDate).substr(0, 10)) : "" }}
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip small dark :color="StatusColor(item.status)">{{ item.status }}</v-chip>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data: () => ({
    search: {
      status: null,
      includeMissing: true,
      expirationFrom: "",
      expirationTo: "",
      search: "",
    },
    // значения — AgreementStatus на бэке (0 Active, 1 Expiring, 2 Expired)
    statusOptions: [
      { text: "Действует", value: 0 },
      { text: "Заканчивается", value: 1 },
      { text: "Истёк", value: 2 },
    ],
    report: { rows: [], activeCount: 0, expiringCount: 0, expiredCount: 0, missingCount: 0 },
    loading: { report: false, download: false },
    headers: [
      { text: "Компания", value: "companyName" },
      { text: "БИН", value: "bin" },
      { text: "Тип компании", value: "companyType" },
      { text: "Файл договора", value: "fileName" },
      { text: "Срок истечения", value: "expirationDate" },
      { text: "Дней до окончания", value: "daysLeft", align: "end" },
      { text: "Статус", value: "status" },
      { text: "Дата внесения", value: "createdDate" },
      { text: "Кто внёс", value: "createdByLogin" },
    ],
  }),
  mounted() {
    this.LoadReport();
  },
  methods: {
    Request() {
      return {
        status: this.search.status === null || this.search.status === undefined ? null : this.search.status,
        includeMissing: this.search.includeMissing,
        expirationFrom: this.search.expirationFrom || null,
        expirationTo: this.search.expirationTo || null,
        search: this.search.search || null,
      };
    },
    async LoadReport() {
      this.loading.report = true;
      try {
        this.report = await this.$store.dispatch("COMPANY_AGREEMENTS_REPORT", this.Request());
      } catch (error) {
        window.console.log(error);
      } finally {
        this.loading.report = false;
      }
    },
    DownloadReport() {
      this.loading.download = true;
      this.$store
        .dispatch("DOWNLOAD_COMPANY_AGREEMENTS_REPORT", this.Request())
        .catch((error) => window.console.log(error))
        .finally(() => {
          this.loading.download = false;
        });
    },
    StatusColor(status) {
      switch (status) {
        case "Действует":
          return "green";
        case "Заканчивается":
          return "orange";
        case "Истёк":
          return "red";
        default:
          return "grey";
      }
    },
  },
};
</script>
